import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import "@/index.css";
import App from "@/App";
import { Toaster } from '@/components/ui/sonner';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light">
      <App />
      <Toaster />
    </ThemeProvider>
  </React.StrictMode>,
);
